<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline " label-width="80px">
			<div class="formOne">
				<el-form-item label="用户手机号">
					<el-input size="medium" clearable v-model="enquiryForm.mobile" placeholder="用户手机号"></el-input>
				</el-form-item>
			</div>
		</el-form>
		<div style="margin-bottom: 10px">
			<el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询
			</el-button>
			<el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
			<el-button size="medium" type="success" style="font-size: 12px;" @click="handleEditFrom()"> 新增</el-button>
		</div>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{ prop: 'id', order: 'descending' }"
			v-loading="loading" border id="tableDataId" size="mini">
			<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="user_name" label="用户名">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="mobile" label="用户手机号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="old_role_name" label="原身份">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="new_role_name" label="升级身份">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="real_name" label="姓名">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="auth_text" label="实名认证">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="creator_name" label="操作人">
			</el-table-column>
			<!-- <el-table-column header-align="center" align="center" prop="creator_mobile" label="操作人手机号">
			</el-table-column> -->
			<el-table-column header-align="center" align="center" prop="create_time" label="操作时间">
			</el-table-column>
		</el-table>
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20, 50, 100, 200, 500, 1000]" :page-size="enquiryForm.limit" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
		<!-- 表格结束 -->

		<el-dialog title="新增" :visible.sync="fromVisible" :before-close="handleClose" width="30%">
			<el-form :model="openAnAccountForm" :rules="rules" ref="ruleForm" label-width="100px">
				<el-form-item label="用户手机号" prop='mobile'>
					<el-input size="medium" clearable v-model="openAnAccountForm.mobile" placeholder="请输入用户手机号"
						@change="initOption" maxlength="11">
					</el-input>
				</el-form-item>
				<el-form-item label="用户名">
					<el-input size="medium" disabled v-model="inviteUserInfo.user_name" placeholder="根据用户手机号自动获取">
					</el-input>
				</el-form-item>
				<el-form-item label="姓名">
					<el-input size="medium" disabled v-model="inviteUserInfo.real_name" placeholder="根据用户手机号自动获取">
					</el-input>
				</el-form-item>
				<el-form-item label="实名认证">
					<el-input size="medium" disabled v-model="inviteUserInfo.auth_text" placeholder="根据用户手机号自动获取">
					</el-input>
				</el-form-item>
				<el-form-item label="用户身份">
					<el-input size="medium" disabled v-model="inviteUserInfo.role_name" placeholder="根据用户手机号自动获取">
					</el-input>
				</el-form-item>
				<el-form-item label="升级身份" prop='role_code'>
					<el-select v-model="openAnAccountForm.role_code" placeholder="请选择升级身份" clearable>
						<el-option v-for="item in inviteUserInfo.role_list" :key="item.role_code" :label="item.role_name"
							:value="item.role_code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "IdentityUpgrade",
	data() {
		return {
			// 主页面部分
			loading: true, //列表loadding
			total: 0, //总数
			tableData: [], //表格数据
			enquiryForm: { //检索条件
				mobile: "", //用户账号
				limit: 20,
				page: 1,
			},

			fromVisible: false, //是否显示表单
			openAnAccountForm: {},
			inviteUserInfo: {},
			rules: { //验证规则 
				mobile: [{
					required: true,
					message: '请输入用户手机号',
					trigger: 'blur'
				}],
				role_code: [{
					required: true,
					message: '请选择升级身份',
					trigger: 'blur'
				}]
			},
		}
	},
	created() {
		this.getData(this.enquiryForm);
	},
	methods: {
		//通过手机号获取用户详情信息
		initOption() {
			if (this.openAnAccountForm.mobile) {
				this.$api.post("/api/system/getMobileToUserInfo", {
					mobile: this.openAnAccountForm.mobile
				}, res => {
					if (res.status == 200) {
						this.inviteUserInfo = res.data;
					} else {
						this.$message.error(res.msg);
						this.inviteUserInfo = {};
						this.openAnAccountForm.mobile = null;
					}
				})
			}
		},
		// 主页面部分
		//搜索
		handleSearch(searchForm) {
			searchForm.page = 1;
			this.getData(searchForm);
		},
		//重置
		Reset(searchForm) {
			searchForm.mobile = "", //角色名称
				searchForm.limit = 20,
				searchForm.page = 1,
				this.getData(searchForm);
		},
		//分页
		handleCurrentChange(page) { //当前选中页
			this.enquiryForm.page = page;
			this.getData(this.enquiryForm);
		},
		handleSizeChange(limit) { //条数
			this.enquiryForm.limit = limit;
			this.enquiryForm.page = 1;
			this.getData(this.enquiryForm);
		},
		//获取数据
		getData(params) { //初始化数据
			this.loading = true;
			this.$api.post("/api/system/userRoleUpList?page=" + params.page, params, res => {
				if (res.status == 200) {
					let tableData = res.data;
					this.total = tableData.total; //总数
					this.tableData = tableData.list;
				} else {
					this.$message.error(res.msg);
				}
				//渲染结束后取消加载
				this.loading = false;
			})
		},

		//编辑打开表单 
		handleEditFrom() {
			this.inviteUserInfo = {};
			this.openAnAccountForm = {};
			this.fromVisible = true;
		},
		handleClose() {
			this.fromVisible = false;
			this.inviteUserInfo = {};
			this.openAnAccountForm = {};
		},
		// 添加表单校验
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 添加确定
					this.$api.post('/api/system/userRoleUp', this.openAnAccountForm, res => {
						if (res.status == 200) {
							this.$message({
								type: 'success',
								message: '操作成功',
								duration: 1000,
							});
							this.handleClose();
							this.enquiryForm.page = 1;
							this.getData(this.enquiryForm);
						} else {
							this.$message.error(res.msg);
						}
					})
				} else {
					return false;
				}
			});
		},
	}
}
</script>
<style scoped>
/deep/ .el-form-item__content .el-input-group {
	vertical-align: middle !important;
}

.code {
	cursor: pointer;
}

.code:hover {
	color: #5111ee;
	text-decoration: underline;
}

/*::v-deep .is-leaf{*/
/*  color: #000000;*/
/*  font-weight: bold;*/
/*  background-color: #e5e4e4;*/
/*}*/
</style>
